import { render, staticRenderFns } from "./ReportAnalisisEstrategicoSaberPro.vue?vue&type=template&id=4e71c090"
import script from "./ReportAnalisisEstrategicoSaberPro.vue?vue&type=script&lang=js"
export * from "./ReportAnalisisEstrategicoSaberPro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports